import StoriesSection from 'design-system/src/components/organisms/StoriesSection';
import { graphql } from 'gatsby';

export default StoriesSection;

export const query = graphql`
    fragment DatoCmsStoriesSection on DatoCmsStoriesSection {
        id
        rootId
        widgetId
        widgetContainer
    }
`;
